'use strict';

exports.__esModule = true;
exports.getAllCompsUnderRoot = getAllCompsUnderRoot;
exports.isTemplateComp = isTemplateComp;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CHILDREN = 'children'; /*eslint no-shadow:0*/

var REPEATER_TYPE = 'wysiwyg.viewer.components.Repeater';

function getAllCompsUnderRoot(model, rootId) {
  var compsUnderRoot = [rootId];
  for (var i = 0; i < compsUnderRoot.length; i++) {
    var children = _lodash2.default.get(model.components, [compsUnderRoot[i], CHILDREN]) || [];
    compsUnderRoot.push.apply(compsUnderRoot, children);
  }
  compsUnderRoot.shift();

  return compsUnderRoot;
}

function isTemplateComp(model, compId) {
  var getCompParent = function getCompParent(compId) {
    return _lodash2.default.get(model, ['components', compId, 'parent']);
  };
  var isCompRepeater = function isCompRepeater(compId) {
    return _lodash2.default.get(model, ['components', currentParent, 'type']) === REPEATER_TYPE;
  }; //eslint-disable-line no-unused-vars
  var currentComp = compId;
  var currentParent = getCompParent(currentComp);
  // search for the parent that is also direct child of a repeater, if exist
  while (currentParent && !isCompRepeater(currentParent)) {
    currentComp = currentParent;
    currentParent = getCompParent(currentComp);
  }
  // if the direct child is in the repeater's children array, then its a template component, otherwise its a displayed only component
  return isCompRepeater(currentParent) && _lodash2.default.includes(_lodash2.default.get(model, ['components', currentParent, 'children']), currentComp);
}
//# sourceMappingURL=modelUtils.js.map